import { CircularProgress } from "@material-ui/core";

export default function Loader() {
    return (
        <div className="flex items-center justify-center w-full h-full">
            <CircularProgress size="3rem" classes={{ svg: "text-navigator-primary" }} />
        </div>
    );
}
